// frontend/src/components/ContactForm.js

import React from 'react';
import { Button } from "./ui/button";

const ContactForm = () => {
  // Google Form の URL（実際の URL に置き換えてください）
  const googleFormUrl = "https://20m-hirosaki-u.notion.site/1368f5933a2d80f1b702c8c74cbc372c?pvs=105";


  // FAQ データ
  const faqItems = [
    {
      question: "配属病院はいつ決定されますか？",
      answer: "配属病院は11月頃に決定し、学務より配布されます。"
    },
    {
      question: "希望する病院を変更することはできますか？",
      answer: "期間内であれば、システム上で希望病院の変更が可能です。"
    },
    {
      question: "システムの利用方法がわかりません",
      answer: "Notionに記載されている「使い方ガイド」をご確認ください。詳しい操作方法を説明しています。"
    },
  ];

  return (
    <div className="max-w-[800px] mx-auto p-5 font-sans">
      <h1 className="text-2xl mb-5 text-primary">お問い合わせ</h1>
      <p className="mb-4 leading-relaxed text-text">
        FAQに記載されていないご質問がある場合は、こちらからお問い合わせください。お問い合わせは、以下のGoogle Formからお願いいたします。
      </p>
      <p className="mb-4 leading-relaxed text-text">
        回答は原則として1週間以内に行います。
      </p>
      <Button 
        onClick={() => window.open(googleFormUrl, '_blank')}
        className="bg-primary text-white px-5 py-2.5 text-base rounded hover:bg-secondary transition-colors duration-300"
      >
        お問い合わせフォームを開く
      </Button>

      {/* FAQ セクション */}
      <div className="mt-12 pt-8 border-t border-border">
        <h2 className="text-xl font-semibold mb-6 text-primary">よくある質問（FAQ）</h2>
        <div className="space-y-6">
          {faqItems.map((item, index) => (
            <div key={index} className="bg-gray-50 p-4 rounded-lg">
              <h3 className="text-lg font-medium text-primary mb-2">Q. {item.question}</h3>
              <p className="text-text">{item.answer}</p>
            </div>
          ))}
        </div>
      </div>

      
    </div>
  );
};

export default ContactForm;
